module.exports = __webpack_public_path__ + "img/mouse_rog_gx1000.9965aae6.jpg";